import _regeneratorRuntime from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _get from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _inherits from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { Renderer } from '../renderer';
var debugModes = {
  DEPTH: require('./shaders/debug.depth.frag'),
  MONO: require('./shaders/debug.mono.frag'),
  RGB: require('./shaders/debug.rgb.frag')
};

var DebugRenderer =
/*#__PURE__*/
function (_Renderer) {
  _inherits(DebugRenderer, _Renderer);

  function DebugRenderer(context, mode, renderActualDepthBuffer, offscreenColorTextureIndex, offscreenComponentIndex) {
    var _this;

    _classCallCheck(this, DebugRenderer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DebugRenderer).call(this, context));
    _this.mode = mode;
    _this.renderActualDepthBuffer = renderActualDepthBuffer;
    _this.offscreenColorTextureIndex = offscreenColorTextureIndex;
    _this.offscreenComponentIndex = offscreenComponentIndex;
    return _this;
  }

  _createClass(DebugRenderer, [{
    key: "customInitAsync",
    value: function () {
      var _customInitAsync = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.context.loadProgramAsync(require('./shaders/debug.vert'), this.mode, ["in_position", "in_textureCoord"], ["u_referenceTexture", "u_componentIndex"]);

              case 2:
                this.program = _context.sent;
                this.vao = this.context.getUnitQuadMesh().makeDrawVao({
                  positions: this.program.attributes.in_position,
                  colorUV: this.program.attributes.in_textureCoord
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function customInitAsync() {
        return _customInitAsync.apply(this, arguments);
      }

      return customInitAsync;
    }()
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(DebugRenderer.prototype), "destroy", this).call(this);

      this.vao.destroy();
      this.program.destroy();
    }
  }, {
    key: "customRender",
    value: function customRender(frameInfo, mountBufferFunc, properties) {
      var GL = this.context.gl;
      var offscreen = this.getOffscreen("reference");

      if (!offscreen) {
        throw new Error("DebugRenderer requires a 'reference' offscreen");
      }

      var textures = offscreen.render(frameInfo, properties);

      if (this.renderActualDepthBuffer) {
        if (!textures.depth) {
          throw new Error("DebugRenderer could not find depth texture in output from offscreen 'reference'");
        }
      } else {
        if (textures.colors.length <= this.offscreenColorTextureIndex) {
          throw new Error("DebugRenderer could not find configured color texture " + this.offscreenColorTextureIndex + " in output from offscreen 'reference'");
        }
      }

      mountBufferFunc();
      GL.disable(GL.CULL_FACE);
      GL.disable(GL.DEPTH_TEST);
      GL.useProgram(this.program.program);

      if (this.renderActualDepthBuffer) {
        this.context.bindTextures([textures.depth], [this.program.uniforms.u_referenceTexture]);
        GL.uniform1i(this.program.uniforms.u_componentIndex, 0);
      } else {
        this.context.bindTextures([textures.colors[this.offscreenColorTextureIndex]], [this.program.uniforms.u_referenceTexture]);
        GL.uniform1i(this.program.uniforms.u_componentIndex, this.offscreenComponentIndex);
      }

      this.vao.draw();
    }
  }]);

  return DebugRenderer;
}(Renderer);

export { debugModes, DebugRenderer };